var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_13451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9238 21.2699C29.9808 21.6802 30.3596 21.9665 30.7699 21.9095C31.1802 21.8525 31.4665 21.4737 31.4095 21.0634L29.9238 21.2699ZM17.0577 19.2116C16.8984 19.5939 17.0792 20.033 17.4616 20.1923C17.8439 20.3516 18.283 20.1708 18.4423 19.7884L17.0577 19.2116ZM18.0833 16.1667C18.0833 15.7525 17.7475 15.4167 17.3333 15.4167C16.9191 15.4167 16.5833 15.7525 16.5833 16.1667H18.0833ZM17.3333 19.5H16.5833C16.5833 19.9142 16.9191 20.25 17.3333 20.25V19.5ZM20.6667 20.25C21.0809 20.25 21.4167 19.9142 21.4167 19.5C21.4167 19.0858 21.0809 18.75 20.6667 18.75V20.25ZM31.4095 21.0634C30.944 17.7139 28.2946 15.0902 24.9407 14.6574L24.7487 16.1451C27.4319 16.4913 29.5514 18.5903 29.9238 21.2699L31.4095 21.0634ZM24.9407 14.6574C21.5868 14.2247 18.3581 16.0899 17.0577 19.2116L18.4423 19.7884C19.4827 17.2911 22.0656 15.7989 24.7487 16.1451L24.9407 14.6574ZM16.5833 16.1667V19.5H18.0833V16.1667H16.5833ZM17.3333 20.25H20.6667V18.75H17.3333V20.25Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0762 22.7301C18.0192 22.3198 17.6404 22.0334 17.2301 22.0905C16.8198 22.1475 16.5335 22.5263 16.5905 22.9365L18.0762 22.7301ZM30.9423 24.7884C31.1016 24.406 30.9208 23.9669 30.5384 23.8077C30.1561 23.6484 29.717 23.8292 29.5577 24.2116L30.9423 24.7884ZM29.9167 27.8333C29.9167 28.2475 30.2525 28.5833 30.6667 28.5833C31.0809 28.5833 31.4167 28.2475 31.4167 27.8333H29.9167ZM30.6667 24.5H31.4167C31.4167 24.0858 31.0809 23.75 30.6667 23.75V24.5ZM27.3333 23.75C26.9191 23.75 26.5833 24.0858 26.5833 24.5C26.5833 24.9142 26.9191 25.25 27.3333 25.25V23.75ZM16.5905 22.9365C17.056 26.2861 19.7054 28.9098 23.0593 29.3425L23.2513 27.8549C20.5681 27.5086 18.4486 25.4097 18.0762 22.7301L16.5905 22.9365ZM23.0593 29.3425C26.4132 29.7753 29.6419 27.91 30.9423 24.7884L29.5577 24.2116C28.5173 26.7089 25.9344 28.2011 23.2513 27.8549L23.0593 29.3425ZM31.4167 27.8333V24.5H29.9167V27.8333H31.4167ZM30.6667 23.75H27.3333V25.25H30.6667V23.75Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#4073F4",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_13451",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.639216 0 0 0 0 0.682353 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_13451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_13451",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBtn);
export default __webpack_public_path__ + "static/media/refresh_btn.bf16d31e062eca3fb7f66871beb103c9.svg";
export { ForwardRef as ReactComponent };